import { AxiosError } from 'axios'
import DataTableControllerWithoutCol from 'components/common/dataTable/dataTableControllerWithoutCol'
import ActiveFilterChip from 'components/common/activeFilterChip'
import PriceLabelReportDataTable from 'components/priceLabelReport/priceLabelReportDataTable'
import PriceLabelReportFilterForm from 'components/priceLabelReport/priceLabelReportFilterForm'
import { FILTER_FIELD_PRICE_LABEL_REPORT } from 'components/priceLabelReport/utils'
import { usePageAccess, useQuery } from 'hooks'
import { useState } from 'react'
import { Helmet } from 'react-helmet'
import toast from 'react-hot-toast'
import { exportPriceLabelReportData } from 'utils/api/priceLabelReportApi'
import { filterEmptyValues } from 'utils/helpers'

const PriceLabelReportPage = () => {
  const { isEditor } = usePageAccess()
  const [showFilter, setShowFilter] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)

  const { getQuery } = useQuery()

  const toggleFilterForm = () => {
    setShowFilter(!showFilter)
  }

  const handleExport = async () => {
    const filters = getQuery(FILTER_FIELD_PRICE_LABEL_REPORT)

    // if no filters found in URL
    if (!filters) {
      return toast.error('Filters are required to export data!', {
        duration: 3000,
      })
    }

    // filtering empty values and keys of filter
    const reportFilters = filterEmptyValues(filters)

    // if filters are present with empty values
    if (Object.keys(reportFilters).length <= 0) {
      return toast.error('Please select at least one filter to export data!', {
        duration: 3000,
      })
    }

    const loadingToast = toast.loading('Loading...', { duration: Infinity })

    try {
      await exportPriceLabelReportData({ filters: reportFilters })
      toast.success('File will be sent to you in email!', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        // Export already running — the API sends a display ready message
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: loadingToast,
            duration: 3000,
          })
        }
      }

      toast.error('Failed to export Price Label Report.', {
        id: loadingToast,
        duration: 3000,
      })
    }
  }

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Price Label Report</title>
      </Helmet>

      <div className="mb-2 flex flex-wrap items-center justify-between md:mb-0 md:flex-nowrap">
        <h3 className="title">Price Label Report</h3>
      </div>

      <DataTableControllerWithoutCol
        isEditor={isEditor}
        handleFilter={toggleFilterForm}
        showFilter={showFilter}
        handleExport={handleExport}
        placeholder="Search by Barcode, Store Code"
        loading={loading}
      />

      {!showFilter && (
        <ActiveFilterChip filterKey={FILTER_FIELD_PRICE_LABEL_REPORT} />
      )}

      {showFilter ? (
        <PriceLabelReportFilterForm toggleFilterForm={toggleFilterForm} />
      ) : (
        <PriceLabelReportDataTable loading={loading} setLoading={setLoading} />
      )}
    </>
  )
}

export default PriceLabelReportPage
